module.exports = __webpack_public_path__ + "static/img/none.170e354b.png";